import { render, staticRenderFns } from "./system_hot_word.vue?vue&type=template&id=5af68f11&scoped=true&"
import script from "./system_hot_word.vue?vue&type=script&lang=js&"
export * from "./system_hot_word.vue?vue&type=script&lang=js&"
import style0 from "./system_hot_word.vue?vue&type=style&index=0&id=5af68f11&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af68f11",
  null
  
)

export default component.exports